import React, {useRef, useContext, useEffect} from "react";
import BasicView from "../../components/BasicView";
import HeadsVies from "../../styles/HeadsVies";
import {SecondView} from "../../styles/HeadView";
import {Content} from "../../styles/GlobalStyles";
import ContactActionForm from "../../components/contact/ContactActionForm";
import DownArrow from "../../components/DownArrow";
import scrollToRef from "../../constants/DownAction";
import {isMobile} from "../../constants/Helpers";
import {HeadersContext} from "../../context/HeadersContext";
import {LoadComponet} from "../../components/loaders/Loader";
import useSetTitle from "../../hooks/useSetTitle";

export default function EnterpriseProgram() {
   useSetTitle("Programa Enterprise");
   const {getHeader, enterpriseHeader} = useContext(HeadersContext);
   const DExperiences = useRef(null);
   const goTo = () => scrollToRef(DExperiences);

   useEffect(() => {
      getHeader("Enterprise");
   }, []);

   if (enterpriseHeader.loading) return <LoadComponet isVisible={true} />;
   return (
      <BasicView
         imageBack={`http://domecqapi.trebolbit.com/${
            isMobile ? enterpriseHeader.pathImageWebMobile : enterpriseHeader.pathImageWebDesktop
         }`}
      >
         <HeadsVies
            type="Enterprise"
            title={
               isMobile ? (
                  <span>Programa enterprise domecq</span>
               ) : (
                  <span>
                     Programa <br /> enterprise domecq
                  </span>
               )
            }
            /* description="Este programa está orientado a todos aquellos representantes de negocio que quieran conocer a
            detalle las marcas y portafolio de productos de Casa Pedro Domecq en una sesión de experiencia,
            conocimiento y degustación." */
            description={enterpriseHeader.description}
         />
         <SecondView>
            <DownArrow goTo={goTo} />
            <Content ref={DExperiences}>
               <ContactActionForm
                  icon={require("../../assets/icons/contact_icon.png")}
                  iconClass="iconMin"
                  centerBtn={true}
                  title="Ponte en contacto"
                  type="enterprise"
               />
            </Content>
         </SecondView>
      </BasicView>
   );
}
